import react, { useState, useEffect } from 'react';
import ExchangeIcon from '../svg/ExchangeIcon';

export default function ExchangeRate({
  displaySymbol = 'USDC',
  colRate = '',
  rate = 4157.57,
  currency = 'COP',
}) {
  return (
    <div className="p-4 bg-[#E6EBF7] rounded-[10px] flex items-center justify-between">
      <div className="flex items-center space-x-1">
        <div className="flex items-center justify-center p-1 bg-[#CDD9F0] rounded-full">
          <ExchangeIcon />
        </div>
        <p className="text-sm text-[#092F7B] font-medium leading-[22px]">Cotización actual</p>
      </div>
      <p className="text-sm text-[#092F7B] font-medium leading-[22px]">
        {`1 ${displaySymbol} = ${colRate ? colRate : rate} ${currency}`}
      </p>
    </div>
  );
}
